export const correctOrganizationsRoute = "organizations";
export const correctGroupsRoute = "groups";
export const correctUsersRoute = "users";
export const competencesRoute = "competences";
export const aiProfilesRoute = "aiProfiles";
export const gymsRoute = "gyms";
export const gamesRoute = "games";
/** Per-game questionnaire responses, scoped by user so RTDB rules can grant access purely by path. */
export const gameFormDataRoute = "gameFormData";
/** The same route is also for the storage */
export const microlearningsRoute = "microlearnings";
export const learningPathsRoute = "paths";
export const journeysRoute = "journeys";
export const learningPathScoresRoute = "learningPathScores";
export const tipsRoute = "tips";
export const formsRoute = "forms";
export const managerNotesRoute = "managerNotes";
